/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the AppEnvironmentApiConfiguration configuration object with a given root URL.
 */
export function provideAppEnvironmentApiConfiguration(rootUrl: string) {
  var config = new AppEnvironmentApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: AppEnvironmentApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AppEnvironmentApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `AppEnvironmentModule.forRoot()`
 */
export interface AppEnvironmentApiConfigurationParams {
  rootUrl?: string;
}
